var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
//!!!! WARNING !!!!!!!!
//This is an auto generated file.
//Changes to this code will be lost if the code is regenerated.
//Generated by: TsAppClientBuilder
//Contact #dev-ui-platform-support in case of issues
import { GeneratedApiClient } from "./ApiClient";
import { DriverAuthNoAuthService } from "./service/DriverAuthNoAuthService";
import { DriverAuthService } from "./service/DriverAuthService";
import { VehicleMarketplaceNoAuthService } from "./service/VehicleMarketplaceNoAuthService";
import { VehicleMarketplaceService } from "./service/VehicleMarketplaceService";
/* tslint:disable:no-namespace */
export var VehicleMarketplace;
(function (VehicleMarketplace) {
    var ApiClient = /** @class */ (function (_super) {
        __extends(ApiClient, _super);
        function ApiClient(config) {
            var _this = _super.call(this, config) || this;
            _this.driverAuth = new DriverAuthService.ApiClient(config);
            _this.driverAuthNoAuth = new DriverAuthNoAuthService.ApiClient(config);
            _this.vehicleMarketplace = new VehicleMarketplaceService.ApiClient(config);
            _this.vehicleMarketplaceNoAuth = new VehicleMarketplaceNoAuthService.ApiClient(config);
            return _this;
        }
        return ApiClient;
    }(GeneratedApiClient));
    VehicleMarketplace.ApiClient = ApiClient;
})(VehicleMarketplace || (VehicleMarketplace = {}));
